import { Component, OnInit } from '@angular/core';
import { SharedRankingListService } from 'src/app/@theme/components/shared-ranking-list/shared-ranking-list.service';



import * as Constants from 'src/app/core/constants';

@Component({
    selector: 'app-beachtennis-ranking',
    templateUrl: './beachtennis-ranking.component.html',
    styleUrls: ['./beachtennis-ranking.component.scss'],
})
export class BeachtennisRankingComponent implements OnInit {
    /**
     * Definição da identificão da sessão/depto Beachtennis
     */
    constants = Constants;
    public departmentType: string = this.constants.DEPARTMENT_TYPE_BEACHTENNIS;
    public pathRoute: string = this.constants.DEPARTMENT_PATH_BEACHTENNIS;

    constructor(private rankingListService: SharedRankingListService) {}

    ngOnInit(): void {}
}
